import { cn } from '@/lib/utils';
import {
  MAP_CONTROL_ACTIVE_CLASS,
  MAP_CONTROL_GROUP_CLASS,
  MAP_CONTROL_SEGMENT_CLASS,
} from '@/styles/mapControl';

const MAP_STYLES = [
  { label: 'Street View', shortLabel: 'Map', isSatellite: false },
  { label: 'Satellite', shortLabel: 'Satellite', isSatellite: true },
] as const;

interface MapStyleToggleProps {
  isSatellite: boolean;
  onChange: (isSatellite: boolean) => void;
  showsOnlyOtherStyle?: boolean;
  className?: string;
}

export function MapStyleToggle({
  isSatellite,
  onChange,
  showsOnlyOtherStyle = false,
  className,
}: MapStyleToggleProps) {
  const shownStyles = showsOnlyOtherStyle
    ? MAP_STYLES.filter((style) => style.isSatellite !== isSatellite)
    : MAP_STYLES;

  return (
    <div className={cn(MAP_CONTROL_GROUP_CLASS, className)}>
      {shownStyles.map((style) => {
        const isActive = isSatellite === style.isSatellite;
        return (
          <button
            key={style.label}
            type="button"
            onClick={() => onChange(style.isSatellite)}
            aria-pressed={showsOnlyOtherStyle ? undefined : isActive}
            title={showsOnlyOtherStyle ? `Switch to ${style.label}` : undefined}
            className={cn(
              MAP_CONTROL_SEGMENT_CLASS,
              isActive || showsOnlyOtherStyle
                ? MAP_CONTROL_ACTIVE_CLASS
                : 'text-muted-foreground hover:bg-muted',
              showsOnlyOtherStyle && 'hover:bg-primary/85',
            )}
          >
            <span className="lg:hidden">{style.shortLabel}</span>
            <span className="max-lg:hidden">{style.label}</span>
          </button>
        );
      })}
    </div>
  );
}
